export default "/fonts/vendor/mdui/dist/roboto/Roboto-RegularItalic.woff2?3a0ee5b0beec8d0ead1336016cbe19ad";